/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HospitalSnfStay } from './HospitalSnfStay';
import {
    HospitalSnfStayFromJSON,
    HospitalSnfStayFromJSONTyped,
    HospitalSnfStayToJSON,
    HospitalSnfStayToJSONTyped,
} from './HospitalSnfStay';

/**
 * 
 * @export
 * @interface HospitalSnfStays
 */
export interface HospitalSnfStays {
    /**
     * 
     */
    snf_stays?: Array<HospitalSnfStay>;
    /**
     * 
     */
    hospital_stays?: Array<HospitalSnfStay>;
}

/**
 * Check if a given object implements the HospitalSnfStays interface.
 */
export function instanceOfHospitalSnfStays(value: object): value is HospitalSnfStays {
    return true;
}

export function HospitalSnfStaysFromJSON(json: any): HospitalSnfStays {
    return HospitalSnfStaysFromJSONTyped(json, false);
}

export function HospitalSnfStaysFromJSONTyped(json: any, ignoreDiscriminator: boolean): HospitalSnfStays {
    if (json == null) {
        return json;
    }
    return {
        
        'snf_stays': json['snf_stays'] == null ? undefined : ((json['snf_stays'] as Array<any>).map(HospitalSnfStayFromJSON)),
        'hospital_stays': json['hospital_stays'] == null ? undefined : ((json['hospital_stays'] as Array<any>).map(HospitalSnfStayFromJSON)),
    };
}

export function HospitalSnfStaysToJSON(json: any): HospitalSnfStays {
    return HospitalSnfStaysToJSONTyped(json, false);
}

export function HospitalSnfStaysToJSONTyped(value?: HospitalSnfStays | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'snf_stays': value['snf_stays'] == null ? undefined : ((value['snf_stays'] as Array<any>).map(HospitalSnfStayToJSON)),
        'hospital_stays': value['hospital_stays'] == null ? undefined : ((value['hospital_stays'] as Array<any>).map(HospitalSnfStayToJSON)),
    };
}

